import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { NFT_LIST, NFT_BUYERS } from "../constants/urls";
import NFTNav from "../components/NavComponents/NFTNav";
import EarlyAccessFooter from "../components/desktop/EarlyAccessFooter";
import ModalBidComponent from "../components/BidComponents/PlaceBidModalComponent";
import ModalMetamaskInstallComponent from "../components/MetamaskInstallComponent/ModalMetamaskInstallComponent";
import {
    useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import twitch from '../assets/twitch.svg';
import box_frame from '../assets/box_frame.png';
import supermessage from '../assets/powers/supermessage.png';
import flashbang from '../assets/powers/flashbang.png';
import autograph from '../assets/powers/autograph.png';
import supermessage_asset from '../assets/powers/supermessage_asset.png';
import flashbang_asset from '../assets/powers/flashbang_asset.png';
import autograph_asset from '../assets/powers/autograph_asset.png';
import eventBus from '../utils/globalPubSub';
import { Bars } from "react-loader-spinner";

import { PaymentContext } from '../utils/paymentConfigProvider';
import { useLocation } from "react-router-dom";
import { consumeUserDirectPerk } from "@/utils/perksUtils";


const CoinGecko = require('coingecko-api');
const CoinGeckoClient = new CoinGecko();


const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const Mobile = styled.div`
  display: none;
  background: #000;
  @media only screen and (max-device-width: 480px) {
  display: flex;
  flex-direction: column;
  }
`;

const CollectorsTitle = styled.div`
  margin-top: 65px;
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 90.1%;
  /* identical to box height, or 38px */

  display: flex;
  align-items: center;

  color: ${props => props.active ? '#FFFFFF': 'rgba(255,255,255,0.45)'};
  margin: 4px;

  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  text-align: center;
  margin-top: 36px;
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 100%;
  /* overflow: hidden; */
  }
`;

const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  /* height: 100vh; */
`;


const MobileContainer = styled.div`
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  /* height: 100vh; */
`;


const CollectorAddress = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 90.1%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
`;

const CollectorBoughtTime = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;

const Perks = styled.div`
  font-family: 'Space Mono';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 90.1%;
  color: #FFFFFF;
`;


const CollectorItemBought = styled.a`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;

const Username = styled.div`    
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 90.1%;
  /* or 25px */
  text-transform: uppercase;
  color: #FFFFFF;
`;

const GradientButton = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #FFFFFF;
  padding: 10px;
  background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
  border-radius: 12px;
`;


const GreenButton = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  padding: 10px;
  position: relative;
  z-index: 1;
  background: rgba(0, 126, 34, 1);
  background-blend-mode: overlay;
  border-radius: 12px;
`;


const HeaderTitle = styled.div`    
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 21px */
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
  opacity: 0.4;
`;


const HeaderValue = styled.div`    
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 90.1%;
  /* identical to box height, or 22px */
  text-align: right;

  color: #FFFFFF;
`;

const GreyTitle = styled.div`    
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #FFFFFF;

  opacity: 0.4;
`;

const Whitetitle = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  /* or 162% */

  display: flex;
  align-items: flex-end;

  color: #FFFFFF;
`;

const Card = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  color: #FFFFFF;
  padding: 35px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
`;

const Title = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 90.1%;
  /* identical to box height, or 20px */

  text-align: center;

  color: #FFFFFF;
  text-transform: uppercase;
`;

const SubTitle = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  display: flex;
  align-items: flex-end;
  text-align: center;

  color: #FFFFFF;

  opacity: 0.4;
  margin-top: 14px;
`;

const DesktopList = styled.div`
  @media only screen and (max-device-width: 480px) {
  margin: 0px!important;
  }
`;

const InputContainerDiv = styled.div`
  width: 100%;
  height: 44px;
  display:flex;
  border: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
`


const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  background: #131313;
  padding: 11px 16px;
  display: flex;
  align-items: center;
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  border: none;
  color: white;
  :placeholder,
  :-webkit-input-placeholder {
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: rgba(255, 255, 255, .4);
  }
`



const PowerImage = ({powerId}) => {
    if(powerId == 14)
        return (<img style={{width: 48, marginRight: 18}} src={supermessage_asset} />);
}

export default function UsePower(props) {
    
    const paymentConfig = useRef({});
    const [data, dataSet] = useState();
    const [activeTab, setActiveTab] = useState('NFT');
    const [bidderMessage, setBidderMessage] = useState('');
    
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    
    const [perks, setPerks] = useState([]);
    const [powers, setPowers] = useState([]);
    const history = useHistory();
    const location = useLocation();
    const { powerId } = useParams();

    useEffect(()=>{
        setSuccess(false);
        setLoader(false);
    }, []);
    
    const usePower = async () => {
        setLoader(true)
        const response = await consumeUserDirectPerk(
            powerId, bidderMessage);
        if(!response || !response.success){
            setError(`You don't have this item`);
            setLoader(false);
        }
        else{
            setSuccess(true);
            setLoader(false);
        }
    }
    
    if (false && !data) {
        return <>
            <Desktop>
                <NFTNav
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    userChainId={1}
                    showTabs={false}
                    expanded={false}
                />
            </Desktop>
        </>;
    }
    
    return (
	<PaymentContext.Provider value={paymentConfig.current}>
            <NFTNav
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                handleWithdrawClicked={()=>{handleWithdrawClicked()}}
                handleDepositClicked={()=>{handleDepositClicked()}}
                userChainId={1}
                showTabs={false}
                expanded={false}
            />
            <Mobile>
                <MobileContainer>
                    <br></br><br></br>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <Username>USER YOUR POWER</Username>
                        <Card>
                            <Title>{location.state.power.name} ON STREAM</Title>
                            <SubTitle>{location.state.power.description}</SubTitle>
                            <InputContainerDiv style={{marginTop: 24}}>
		                <StyledInput
                                    maxLength="15"
		                    placeholder={
                                    "Send message to live stream"}
		                    value={bidderMessage}
		                    onChange={e =>{
                                        setBidderMessage(
                                            e.target.value)}}
                                
		                />
	                    </InputContainerDiv>
                            <GradientButton 
                                className='hover'
                                style={{width: '100%', marginTop: 50}}
                                onClick={() => usePower()}>
                                {(loader) && (
                                    <Bars height="30" width="30"
                                          color="grey"
                                          arialLabel="loading-indicator" />
                                )}
                                {(!loader && !success && !error) && (
                                    <>USE POWER</>
                                )}
                                {(success && !error) && (
                                    <>Power Fired</>)}
                                {(error) && (
                                    <>{error}</>)}
                                
                            </GradientButton>
                        </Card>
                    </div>               
                </MobileContainer>
                <EarlyAccessFooter />
            </Mobile>   
	    <Desktop>
                <Container>
                    <br></br><br></br>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <Username>USER YOUR POWER</Username>
                        <Card>
                            <Title>{location.state.power.name} ON STREAM</Title>
                            <SubTitle>{location.state.power.description}</SubTitle>
                            <InputContainerDiv style={{marginTop: 24}}>
		                <StyledInput
                                    maxLength="15"
		                    placeholder={
                                    "Send message to live stream"}
		                    value={bidderMessage}
		                    onChange={e =>{
                                        setBidderMessage(
                                            e.target.value)}}
                                
		                />
	                    </InputContainerDiv>
                            <GradientButton 
                                className='hover'
                                style={{width: '100%', marginTop: 50}}
                                onClick={() => usePower()}>
                                {(loader) && (
                                    <Bars height="30" width="30"
                                          color="grey"
                                          arialLabel="loading-indicator" />
                                )}
                                {(!loader && !success && !error) && (
                                    <>USE POWER</>
                                )}
                                {(success && !error) && (
                                    <>Power Fired</>)}
                                {(error) && (
                                    <>{error}</>)}
                                
                            </GradientButton>
                        </Card>
                    </div>               
                </Container>
                <EarlyAccessFooter />
	    </Desktop>
	</PaymentContext.Provider>
    );
}

